import { render, staticRenderFns } from "./coachGiftManage.vue?vue&type=template&id=499aa31c&scoped=true"
import script from "./coachGiftManage.vue?vue&type=script&lang=ts"
export * from "./coachGiftManage.vue?vue&type=script&lang=ts"
import style0 from "./coachGiftManage.vue?vue&type=style&index=0&id=499aa31c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499aa31c",
  null
  
)

export default component.exports